import React, { useEffect } from 'react'
import { loadIpInfo } from '../helpers/misc'
import { segmentAnonymousId, segmentEvent, segmentPageView } from '../helpers/tracking'

// const FACEBOOK_PIXEL_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID
// const GORGIAS_CHAT_ID = process.env.NEXT_PUBLIC_GORGIAS_CHAT_ID

const externalScripts = [
  // segment
  {
    id: 'segment',
    innerHTML: `
      !(function () {
        var analytics = (window.analytics = window.analytics || [])
        if (!analytics.initialize)
          if (analytics.invoked)
            window.console &&
              console.error &&
              console.error('Segment snippet included twice.')
          else {
            analytics.invoked = !0
            analytics.methods = [
              'trackSubmit',
              'trackClick',
              'trackLink',
              'trackForm',
              'pageview',
              'identify',
              'reset',
              'group',
              'track',
              'ready',
              'alias',
              'debug',
              'page',
            'once',
            'off',
            'on',
            'addSourceMiddleware',
            'addIntegrationMiddleware',
            'setAnonymousId',
            'addDestinationMiddleware'
          ]
          analytics.factory = function (e) {
            return function () {
              var t = Array.prototype.slice.call(arguments)
              t.unshift(e)
              analytics.push(t)
              return analytics
            }
          }
          for (var e = 0; e < analytics.methods.length; e++) {
            var key = analytics.methods[e]
            analytics[key] = analytics.factory(key)
          }
          analytics.load = function (key, e) {
            var t = document.createElement('script')
            t.type = 'text/javascript'
            t.async = !0
            t.src =
              'https://cdn.segment.com/analytics.js/v1/' +
              key +
              '/analytics.min.js'
            var n = document.getElementsByTagName('script')[0]
            n.parentNode.insertBefore(t, n)
            analytics._loadOptions = e
          }
          analytics._writeKey = '${process.env.NEXT_PUBLIC_SEGMENT_KEY}'
          analytics.SNIPPET_VERSION = '4.15.3'
          analytics.load('${process.env.NEXT_PUBLIC_SEGMENT_KEY}')
          analytics.page()
        }
      })()
    `
  },
  // crazy egg
  {
    type: 'text/javascript',
    src: '//script.crazyegg.com/pages/scripts/0105/1499.js',
    async: 'async',
    id: 'script-crazy-egg',
    defer: true
  },
  // share a sale
  {
    type: 'text/javascript',
    src: 'https://www.dwin1.com/46067.js',
    async: 'async',
    id: 'share-a-sale',
    defer: true
  },
  // google tag manager
  {
    id: 'google-tag-manager',
    innerHTML: `
      ;(function (w, d, s, l, i) {
        w[l] = w[l] || []
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : ''
        j.async = true
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
        f.parentNode.insertBefore(j, f)
      })(
        window,
        document,
        'script',
        'dataLayer',
        '${process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID}'
      )
    `
  },
]

let injected = false;
const injectScripts = async () => {
  if (injected) {
    return;
  }
  injected = true

  if (typeof window === 'undefined') {
    return
  }

  // skip analytics for certain ip addresses
  const ipInfo = await loadIpInfo()  
  if (ipInfo?.ip?.startsWith('40.94.')) { // some bot in Azure
    return
  }

  externalScripts.forEach((externalScript) => {
    if (typeof externalScript === 'function') {
      externalScript();
      return
    }

    const scriptExists = document.getElementById(externalScript.id)
    if (scriptExists) {
      return
    }

    const scriptElement = document.createElement('script')
    scriptElement.onerror = err => {
      console.warn('error loading script', err)
    }

    Object.entries(externalScript)
      .forEach(([key, value]) => {
        scriptElement[key] =
          key !== 'innerHTML'
            ? value
            : // wrap in try/catch if
            `
              try {
                ${value}
              } catch (err) {
                console.warn('loading executing script', err)
              }
            `
      });
    document.body.appendChild(scriptElement);
  })

  const analytics = window.analytics
  if (!analytics) {
    console.warn('analytics not loaded')
    return
  }

  // ensure segment anon id is set after segment loads
  segmentAnonymousId()

  segmentEvent('Web Opened');

  segmentPageView(window.location.pathname)
}

export default React.memo(
  () => {
    useEffect(() => {
      let timeout
      timeout = setTimeout(injectScripts, 10000)
      return () => clearTimeout(timeout)
    }, [])
    return null
  },
  () => true
)
